<template>
  <div class="person-info">
    <div class="top">
      <p style="font-size: 12px">
        <span>派警用户管理 > </span>
        <span>查看</span>
      </p>
      <el-button type="primary" @click="closeDialog">返回</el-button>
    </div>
    <div class="middle">
      <div class="middle-left">
        <img :src="userInfo.portrait" alt="" srcset="" />
        <div class="info">
          <p>
            <span>姓名：</span><span>{{ userInfo.realName }}</span>
          </p>
          <p>
            <span>手机号：</span><span>{{ userInfo.phone }}</span>
          </p>
          <p>
            <span>用户类型：</span><span>{{ typeName }}</span>
          </p>
          <p>
            <span>指挥中心：</span><span>{{ areaName }}</span>
          </p>
        </div>
      </div>
      <div class="middle-right">
          <el-date-picker
          @change="choosedMonth"
      v-model="valueDate"
      type="month"
      placeholder="选择日期">
    </el-date-picker>
        <el-calendar v-if="showDate" v-model="dayDate">
          <template slot="dateCell" slot-scope="{ data }">
            <p
              :class="data.isSelected ? 'is-selected' : 'day-box'"
              @click="changeData(data.day)"
            >
              {{ data.day.split("-").slice(1)[1] }}
              <!-- {{ data.isSelected ? "✔️" : "" }} -->
              {{
                checkedDays.findIndex((item) => {
                  return item.createGmt.split(" ")[0] == data.day;
                }) != -1
                  ? "✔️"
                  : ""
              }}
            </p>
          </template>
        </el-calendar>
      </div>
    </div>
    <div class="bottom">
      <el-tabs type="border-card" v-model="choosedTab" @tab-click="clickTab">
        <el-tab-pane label="任务" name="task">
          <div style="margin-top: 20px">
            <el-radio-group v-model="radio3" size="small" @change="changeRadio">
              <el-radio-button label="全部"></el-radio-button>
              <el-radio-button label="当月"></el-radio-button>
              <el-radio-button label="当天"></el-radio-button>
            </el-radio-group>
          </div>
          <Table
            :width="'100%'"
            :tableLoading="tableLoading"
            :tabelButtons="tabelButtons"
            :templateData="tableTemplateData"
            :tableConfig="tableConfig"
            :pagination="pagination"
          ></Table>
        </el-tab-pane>
        <el-tab-pane label="轨迹" name="line">
          <div style="display:flex;height: 100%; width: 100%">
              <div id="map-container" style="height: 100%; width: 100%"></div>
                <div class="sate-box">
                        <div class="start item-state">
                            <p>
                                <span>签到时间：</span>
                            </p>
                            <p>
                                <span>{{infoState.length>0?infoState[0].updateGmt:'未签到'}}</span>
                                <span>{{infoState.length>0?infoState[0].address:''}}</span>
                            </p>
                        </div>
                        <div class="end item-state">
                            <p>
                                <span>签退时间：</span>
                            <p>
                                <span>{{infoState.length>1?infoState[1].updateGmt:'未签退'}}</span>
                                <span>{{infoState.length>1?infoState[1].address:''}}</span>
                            </p>
                        </div>
                </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog :visible.sync='showLog' :append-to-body="true">
        <div style="max-height: 500px;overflow: auto;">
            <alarm-detail-box :alarm-detail-data="alarmData"></alarm-detail-box>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
import { systemApi } from "@/api-path/system-api.js";
import { userApi } from "@/api-path/user-api.js";
    import {listAPI} from '@/api-path/command-center.js'
import AlarmDetailBox from '../../command-center/comand-center-contaniner/alarm-detail-box/alarm-detail-box'
let carInfo;
export default {
  name: "person-info",
  props: ["personId", "typeName", "areaName"],
  components:{
      AlarmDetailBox
  },
  data() {
    return {
        valueDate:new Date(),
      dayDate: new Date(),
      checkedDays: [],
      showDate: false,
      choosedTab: "task",
      currentDay: new Date().Format("yyyy-MM-dd"),
      infoState:[],

      radio3: "全部",
      searchParams: {
        type: null, //1.日查询 2.月查询
        cTime: "", //(new Date()).Format("yyyy-MM")
        userId: this.personId,
        page: 1,
        size: 15,
      },
      tableLoading: false,
      tabelButtons: [],
      dialogVisible: false,
      dialogVisible1: false,
      tableTemplateData: [],
      tableConfig: {
        checkbox: false,
        rows: [
          {
            label: "分派时间",
            prop: "disTime",
            width: "120px",
          },
          {
            label: "报警时间",
            prop: "happenDate",
            width: "120px",
          },
          {
            label: "报警人",
            prop: "userName",
          },
          {
            label: "区域",
            prop: "areaName",
          },
          {
            label: "接警中心",
            prop: "centerName",
          },
          {
            label: "报警来源",
            prop: "sourceName",
          },
          {
            label: "报警方式",
            prop: "alarmName",
          },
          {
            label: "内容",
            prop: "content",
            type: "popover",
            width: "180px",
          },
          {
            label: "报警地点",
            prop: "address",
            type: "popover",
            width: "180px",
          },
          {
            label: "状态",
            prop: "statusName",
          },
        ],
        rowButtons: {
          width: "300px",
          items: [
            {
              label: "查看",
              type: "primary",
              fn: (data) => {
                   this.$http.get(listAPI.datail + '?alarmId=' + data.id).then(res => {
                    this.showLog = true
                    res.result.handlers.map(item => {
                        item.isOpen = false
                    })
                    this.alarmData = res.result;
                })
              },
            },
          ],
        },
      },
      pagination: {
        show: true,
        total: 0,
        page: 1,
        size: 15,
        sizeChange: this.sizeChange,
        pageChange: this.pageChange,
      },
      userInfo: {},
      showLog:false,
      alarmData:'',
      /* 地图相关 */
      mapConfig: {
        map: null, // 地图实列
        zoom: 8,
        oldZoom: "",
        areaId: "51",
        oldAreaId: "51",
        oldCenter: "",
        zoomDifference: 0, // 缩放层级差值
        police_data: {},
        police_track: false, // 是否正在显示轨迹
      },
    };
  },
  created() {
    this.getMonthCheck();
    this.getUserInfo();
    this.startSearch();
  },
  mounted() {
    this.initMap();
  },
  methods: {
    closeDialog() {
      this.$emit("closePerson");
    },
    //切换月份
    choosedMonth(data){
        let m=data.Format('yyyy-MM');
        let n=new Date().Format('yyyy-MM');
        if(m==n){
            this.dayDate=new Date();
            this.currentDay=new Date().Format('yyyy-MM-dd')
        }else{
            this.dayDate=data;
            this.currentDay=data.Format('yyyy-MM')+'-01'
        }
        this.getMonthCheck();

        if(this.choosedTab=='line'){
            this.initMap();
            this.infoByState();
        }else{
            this.radio3="当月";
            this.changeRadio();
        }
    },
    clickTab(item) {
        this.choosedTab=item.name;
      if ((item.name = "line")) {
        this.initMap();
        this.infoByState();
      }
    },
    // 每页显示条数
    sizeChange(size) {
      this.pagination.size = size;
      this.searchParams.size = size;
      this.startSearch();
    },
    // 当前页
    pageChange(page) {
      this.pagination.page = page;
      this.searchParams.page = page;
      this.startSearch();
    },
    startSearch() {
      this.$http
        .get(systemApi.queryUserByDate, { params: this.searchParams })
        .then((res) => {
          this.tableLoading = false;
          if (res.status == 200) {
            this.tableTemplateData = res.result.pageList;
            this.pagination.total = res.result.total;
          }
        });
    },
    changeData(day) {
      this.currentDay = day;
      if(this.choosedTab=='line'){
          this.mapConfig.map.clearMap()
          this.getTrack();
          this.infoByState();
      }else{
        this.radio3 = "当天";
        this.searchParams = {
            type: 1, //1.日查询 2.月查询
            cTime: day, //(new Date()).Format("yyyy-MM")
            userId: this.personId,
            page: 1,
            size: 15,
        };
        this.startSearch();
      }
    },
    changeRadio() {
      switch (this.radio3) {
        case "全部":
          this.searchParams = {
            type: null, //1.日查询 2.月查询
            cTime: "", //(new Date()).Format("yyyy-MM")
            userId: this.personId,
            page: 1,
            size: 15,
          };
          this.startSearch();
          break;
        case "当月":
          this.searchParams = {
            type: 2, //1.日查询 2.月查询
            cTime: this.currentDay, //(new Date()).Format("yyyy-MM")
            userId: this.personId,
            page: 1,
            size: 15,
          };
          this.startSearch();
          break;
        case "当天":
          this.searchParams = {
            type: 1, //1.日查询 2.月查询
            cTime: this.currentDay, //(new Date()).Format("yyyy-MM")
            userId: this.personId,
            page: 1,
            size: 15,
          };
          this.startSearch();
          break;
      }
    },
    //获取用户详情
    getUserInfo() {
      this.$http.get(userApi.viewUser, { params: { id: this.personId } }).then((res) => {
        if (res.status == 200) {
          this.userInfo = res.result;
        }
      });
    },
    //获取本月签到记录
    getMonthCheck() {
      this.$http
        .get(systemApi.queryByDate, {
          params: { cTime: new Date(this.currentDay).Format("yyyy-MM-dd"), userId: this.personId },
        })
        .then((res) => {
          if (res.status == 200) {
            this.showDate = true;
            this.checkedDays = res.result;
          }
        });
    },
    //获取签到签退
    infoByState(){
        this.$http.get(systemApi.findListByDate,{params:{userId:this.personId,date:this.currentDay}}).then(res=>{
            if(res.status==200){
                this.infoState=res.result;
            }
        })
    },
    //获取轨迹
    getTrack() {
      this.$http
        .get(systemApi.userTrack, {
          params: { userId: this.personId, startDate: this.currentDay },
        })
        .then((res) => {
          if (res.status == 200) {
            if (res.result) {
              this.mapConfig.police_data.position = [];
              res.result.forEach((item) => {
                this.mapConfig.police_data.position.push([item.longitude, item.latitude]);
              });
              this.mapConfig.police_track = true;
              this.mapConfig.map.clearMap();
              this.mapConfig.oldZoom = this.mapConfig.map.getZoom();
              this.mapConfig.oldCenter = this.mapConfig.map.getCenter();
              this.personIcon();
            } else {
              this.$message.error("暂无轨迹信息！");
            }
          }
        });
    },
    // 绘制轨迹
    personIcon() {
      let data = this.mapConfig.police_data
      new AMap.Polyline({
        map: this.mapConfig.map,
        path: data.position,
        showDir:true,
        strokeColor: "#ff0002",  //线颜色
        strokeOpacity: 0.8,     //线透明度
        strokeWeight: 6,      //线宽
        strokeStyle: "solid"  //线样式
      });

      let personIconStart = new AMap.Marker({
        position: data.position[0],
        content: `<p class="track_icon">起</p>`,
        offset: new AMap.Pixel(-15, -50)
      })
      
      carInfo = new AMap.Marker({
        position: data.position[0],
        content: `<img style="height: 50px;border-radius: 50%" src="${data.portrait}">`,
        offset: new AMap.Pixel(-25, -15)
      })

      let personIconEnd = new AMap.Marker({
        position: data.position[data.position.length - 1],
        content: `<p class="track_icon">终</p>`,
        offset: new AMap.Pixel(-25,-15)
      })

      let markers = [personIconStart, personIconEnd, carInfo]
      markers.forEach(item => {
        item.on('click', () => {
          this.clearTrack(markers)
        })
      })

      this.mapConfig.map.setFitView()
      this.mapConfig.map.add(markers);
      carInfo.moveAlong(data.position, 100);
    },
    /* 清除轨迹 */
    clearTrack(marker) {
      marker.forEach(item => {
        this.mapConfig.map.remove(item)
      })
      this.mapConfig.police_track = false
      this.mapConfig.map.setZoom(this.mapConfig.oldZoom)
      this.mapConfig.map.setCenter(this.mapConfig.oldCenter)
    },
    /* 初始化地图 */
    initMap() {
      const $this = this;
      let initZoom = 8;
      let mapConfig = $this.mapConfig;
      mapConfig.map = new AMap.Map("map-container", {
        resizeEnable: true,
        zoom: initZoom,
        viewMode: "2D",
        layers: [new AMap.TileLayer()],
        zooms: [5, 18],
      });

      AMap.plugin(["AMap.MapType"], function () {
        const mapType = new AMap.MapType(); // 地图种类
        mapConfig.map.addControl(mapType);
      });

      mapConfig.map.on("zoomend", $this.zoomCount);
      AMap.plugin(["AMap.MouseTool"], function () {
        $this.mouseTool = new AMap.MouseTool($this.mapConfig.map);
      });
        this.getTrack();
      
    },
  },
};
</script>

<style lang="less">
.person-info {
  height: calc(100vh - 80px);
  position: fixed;
  top: 70px;
  left: 240px;
  width: calc(100vw - 240px);
  z-index: 11;
  background: #fff;
  display: flex;
  flex-direction: column;
  .top {
    height: 50px;
    border-bottom: 5px solid #f1f4fb;
    margin: 0;
    padding: 0px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .middle {
    display: flex;
    align-items: center;
    height: 290px;
    max-height: inherit;
    margin: 0;
    .middle-left {
      width: 400px;
      display: flex;
      align-items: center;
      height: 100%;
      background: #fff;
      padding: 0 20px;
      box-sizing: border-box;
      img {
        width: 120px;
        height: 120px;
      }
      .info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        height: 120px;
        padding: 0 10px;
      }
    }
    .middle-right {
      flex: 1;
      position: relative;
      .el-date-editor{
          position: absolute;
          right: 10px;
      }
      .el-calendar__button-group{
          display: none;
      }
      .el-calendar__header {
        padding: 12px 0;
      }
      .el-calendar__body {
        padding: 0;
        .el-calendar-table .el-calendar-day {
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0;
          .day-box {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
      }
    }
  }
  .bottom {
    flex: 1;
    .el-tabs--border-card {
      height: 100%;
      box-shadow: none;
      border: 0;
      border-top: 1px solid #ccc;
      .el-tabs__content {
        height: calc(100% - 39px);
        width: 100%;
        box-sizing: border-box;
        .el-tab-pane {
          width: 100%;
          height: 95%;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
        }
      }
    }
    .sate-box{
        margin: 0 20px;
        width: 400px;
        .item-state{
            display: flex;
            p{
                &:nth-child(2){
                flex: 1;
                display: flex;
                flex-direction: column;
                span{
                    &:first-child{
                        line-height: 24px;
                    }
                    &:last-child{
                        font-size: 12px;
                        color: #999;
                    }
                }
                }
            }
        }
        .start{
            position: relative;
            height: 190px;
            &::after{
                content: '';
                position: absolute;
                height: 150px;
                width: 1px;
                background: #ccc;
                top: 30px;
                left: 30px;
            }
        }
    }
  }
}
</style>
